import React from 'react';
import { Heart, MessageCircle, User, Settings, Flame, ArrowLeft, Brain } from 'lucide-react';
import NotificationBell from './NotificationBell';
import { BrandLockup } from './BrandLogo';

const Navbar = ({ currentView, setCurrentView, onBackToLanding }) => {
  const navItems = [
    { id: 'discover', icon: Flame, label: 'Discover', color: 'text-red-500' },
    { id: 'matches', icon: Heart, label: 'Matches', color: 'text-pink-500' },
    { id: 'messages', icon: MessageCircle, label: 'Messages', color: 'text-blue-500' },
    { id: 'settings', icon: Settings, label: 'Settings', color: 'text-gray-600' },
    { id: 'insights', icon: Brain, label: 'AI Insights', color: 'text-indigo-500' },
    { id: 'profile', icon: User, label: 'Profile', color: 'text-gray-600' }
  ];

  return (
    <>
      {/* Top Header */}
      <header className="bg-white shadow-sm border-b sticky top-0 z-50">
        <div className="container mx-auto px-4 py-4 flex items-center justify-between">
          {/* Back Button */}
          <button
            onClick={onBackToLanding}
            className="flex items-center text-gray-600 hover:text-red-500 transition-colors"
            title="Back to Main Page"
          >
            <ArrowLeft className="w-5 h-5 mr-1" />
            <span className="text-sm font-medium">Back</span>
          </button>
          
          {/* Logo */}
          <BrandLockup size="md" />
          
          {/* Notification Bell */}
          <NotificationBell />
        </div>
      </header>

      {/* Bottom Navigation */}
      <nav className="fixed bottom-0 left-0 right-0 bg-white border-t shadow-lg z-50">
        <div className="flex justify-around items-center py-2">
          {navItems.map((item) => {
            const Icon = item.icon;
            const isActive = currentView === item.id;
            
            return (
              <button
                key={item.id}
                onClick={() => setCurrentView(item.id)}
                className={`flex flex-col items-center p-2 transition-all duration-200 ${
                  isActive 
                    ? `${item.color} scale-110` 
                    : 'text-gray-400 hover:text-gray-600'
                }`}
              >
                <Icon className="w-6 h-6" />
                <span className="text-xs mt-1 font-medium">{item.label}</span>
              </button>
            );
          })}
        </div>
      </nav>
    </>
  );
};

export default Navbar;